import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-listing-search',
  standalone: false,
  templateUrl: './listing-search.component.html',
  styleUrl: './listing-search.component.scss'
})
export class ListingSearchComponent {

  @Input() placeholder:string = 'Search';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Output() search:EventEmitter<string> = new EventEmitter<string>();

  searchQuery: string = '';

  constructor(){}

  emitSearchValue(){
    this.search.emit(this.searchQuery);
  }

  clearSearch(){
    this.searchQuery = '';
    this.emitSearchValue();
  }

}
